<template>
  <footer>
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="10">
					<b-container fluid>
						<b-row>
							<b-col sm="12" md="3">
								<img :src="computedLogo" alt="Logo" />
							</b-col>
							<b-col sm="12" md="4">
								<div v-html="sanitizedContactInfo"></div>
								<ul>
									<li>
										<a :href="phone.url">{{ phone.title }}</a>
									</li>
									<li>
										<a :href="email.url">{{ email.title }}</a>
									</li>
								</ul>
							</b-col>
							<b-col sm="12" md="5" class="d-flex justify-content-end">
								<div v-html="sanitizedCompanyName"></div>
							</b-col>
						</b-row>
					</b-container>
				</b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    locale: String,
		companyName: String,
		contactInfo: String,
		email: Object,
		phone: Object,
		logo: Object,
		privacyLink: Object,
		termsLink: Object
  },
	computed: {
		computedLogo() {
			return `/strapi/${this.logo.data.attributes.url}`
		},
		sanitizedContactInfo() {
			return DOMPurify.sanitize(marked(this.contactInfo))
		},
		sanitizedCompanyName() {
			return DOMPurify.sanitize(marked(this.companyName))
		}
	}
}
</script >

<style scoped src="@/assets/css/footer.css" />
